module.exports = __webpack_public_path__ + "static/media/bannerCyber.0bf8e5cd.jpg";